<div class="horizontal-list">
  <div class="category-items-header">
    <div class="category-name">{{ categoryItem.category.name }}</div>
    <div
      tappable
      *ngIf="hasMoreItems || (!isBrowser && categoryItem.category.totalItemsCount > 1)"
      class="view-more-items-header"
      data-cy="view-more-button"
      (click)="onOpenCategoryDetails()"
    >
      {{
        categoryItem.category.totalItemsCount
          ? ("VIEW_ALL_X_ITEMS" | translate : { quantity: categoryItem.category.totalItemsCount })
          : ("VIEW_ALL" | translate)
      }}
    </div>
  </div>

  <div *ngIf="!isBrowser" class="category-items-wrapper">
    <div #scrollElement class="category-items">
      <app-grocery-item
        [item]="item"
        [address]="address"
        [vendorDetails]="vendorDetails"
        *ngFor="let item of categoryItem.menuItems"
      ></app-grocery-item>

      <div class="view-more-items" *ngIf="hasMoreItems" tappable (click)="onOpenCategoryDetails()">
        <div class="view-more-button">
          <ion-icon name="eye-outline"></ion-icon>
        </div>
        <span>
          {{
            categoryItem.category.totalItemsCount
              ? ("VIEW_ALL_X_ITEMS" | translate : { quantity: categoryItem.category.totalItemsCount })
              : ("VIEW_ALL" | translate)
          }}
        </span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isBrowser">
    <div class="category-items-container">
      <div [id]="'prev-' + categoryItem.category.categoryId" class="category-items-button btn-previous" tappable>
        <ion-icon class="category-items-button-icon" name="chevron-back-outline"></ion-icon>
      </div>

      <swiper #swiper #scrollElement [dir]="browserSliderDirection" [config]="browserSliderConfig" class="category-items">
        <ng-template swiperSlide *ngFor="let item of categoryItem.menuItems">
          <app-grocery-item [item]="item" [address]="address" [vendorDetails]="vendorDetails"></app-grocery-item>
        </ng-template>

        <ng-container *ngIf="hasMoreItems">
          <ng-template swiperSlide>
            <div class="view-more-items" tappable (click)="onOpenCategoryDetails()">
              <ion-icon name="eye-outline"></ion-icon>
              <span>
                {{
                  categoryItem.category.totalItemsCount
                    ? ("VIEW_ALL_X_ITEMS" | translate : { quantity: categoryItem.category.totalItemsCount })
                    : ("VIEW_ALL" | translate)
                }}
              </span>
            </div>
          </ng-template>
        </ng-container>
      </swiper>

      <div [id]="'next-' + categoryItem.category.categoryId" class="category-items-button btn-next" tappable>
        <ion-icon class="category-items-button-icon" name="chevron-forward-outline"></ion-icon>
      </div>
    </div>
  </ng-container>
</div>
